// Legacy alias — canonical route is /automations/[pathID]. IDs unchanged.
import { Redirect, useLocalSearchParams } from 'expo-router';

export default function PathDetailAlias() {
    const params = useLocalSearchParams();
    return <Redirect href={{ pathname: '/automations/[pathID]', params }} />;
}
